export const sortOrder = {
  valueAscending: 0,
  valueDescending: 1,
};
